import { Rule } from "antd/es/form";
import i18n from "src/i18n";
import { RequiredField } from "src/store/slices/item/subitems/px.types";

const VALIDATION_RULES:Record<string, Rule[]> = {
    UserName:[{
        pattern: /^[a-zA-Z0-9_.-]{2,30}$/,
        get message() {
          return i18n.t("PointsExchange.exchange.validUsername");
        }
    },{
        required:true,
        get message() {
          return i18n.t("PointsExchange.exchange.fieldRequired");
        }
    }],
    PhoneNumber:[{
        pattern:/^\+?[0-9\s\-().]{7,15}$/,
        get message() {
          return i18n.t("PointsExchange.exchange.validPhoneNumber");
        }
    },{
        required:true,
        get message() {
          return i18n.t("PointsExchange.exchange.fieldRequired");
        }
    }]
}


type ExchangeInfoType = {
    fees:number;
    conversionRate:number;
    sourceUnitLabel?:string;
    destinationUnitLabel:string;
    min:number;
    max:number;
}

type ProgramType = {
    name:string;
    imageUrl?:string;
    value?:string;
    unitLabel?:string;
}

type RequiredFieldType = RequiredField;

type DestinationProgramType = {
    name:string;
    coee?:string;
    imageUrl?:string;
    unitLabel?:string;
}

type ProgramExchangeDetailsType = {
    requiredFields:RequiredFieldType[];
    destinationProgram:DestinationProgramType;
    exchangeInfo:ExchangeInfoType,
    termsAndConditions:string;    
    loading?:boolean;
    error?:any;
    points?:number;
}

 


export {VALIDATION_RULES};
export type{ExchangeInfoType, ProgramType, RequiredFieldType, ProgramExchangeDetailsType};